/**
 * Brightness Style04 - Stitch 設計：標題 + light_mode 圖示、灰→白滑桿、Dim/Brilliant
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import { resolveRangeFromAttributes } from './traitStyleConfig'
import './BrightnessStyle04.css'

export function BrightnessStyle04({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { min: MIN, max: MAX } = resolveRangeFromAttributes(attributes, trait, 'brightness')
  const raw = (state?.brightness as number) ?? Math.round((MIN + MAX) / 2)
  const currentBrightness = Math.max(MIN, Math.min(MAX, raw))
  const [brightness, setBrightness] = useState(currentBrightness)

  useEffect(() => {
    const v = Math.max(MIN, Math.min(MAX, (state?.brightness as number) ?? Math.round((MIN + MAX) / 2)))
    setBrightness(v)
  }, [state?.brightness, MIN, MAX])

  const handleChange = (value: number) => {
    const clamped = Math.max(MIN, Math.min(MAX, Math.round(value)))
    setBrightness(clamped)
    void onCommand('setBrightness', { brightness: clamped })
  }

  return (
    <div className="trait-brightness-style04 trait-stitch-glass">
      <div className="trait-brightness-style04__header">
        <span className="trait-brightness-style04__title">Brightness</span>
        <span className="material-symbols-outlined trait-brightness-style04__icon">light_mode</span>
      </div>
      <input
        type="range"
        min={MIN}
        max={MAX}
        value={brightness}
        onChange={(e) => setBrightness(Number(e.target.value))}
        onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        className="trait-brightness-style04__slider"
        disabled={disabled}
      />
      <div className="trait-brightness-style04__labels">
        <span>Dim</span>
        <span>Brilliant</span>
      </div>
    </div>
  )
}
